'use client';

import { useEffect, useState } from 'react';
import { getMessages } from '@/lib/actions/messages';
import { MessageList } from '@/components/admin/messages/MessageList';

export default function AdminMessagesPage() {
  const [messages, setMessages] = useState<Awaited<ReturnType<typeof getMessages>>>([]);

  useEffect(() => {
    getMessages().then(setMessages);
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-navy">Contact Messages</h1>
        <p className="text-muted-foreground mt-1">View and manage inquiries from your website.</p>
      </div>

      <MessageList initialMessages={messages} />
    </div>
  );
}
